export default "__VITE_ASSET__CgBUqSP9__"